export enum CustomPaginationType {
  CUSTOM = 'custom'
}
